import React from 'react';
import Navbar from '../Navbar';
import { Link } from 'react-router-dom';
import './StartWrtingComp.css'
export default function ShowApprove(){
    return(
        <>
       <Navbar showmenu={false}/>
      <div className="container" style={{ marginTop: '100px', position: 'relative'}}>
       <div id="startWritingForm">
       <div class="mb-4 d-flex align-items-center justify-content-center">
        <h1>Approve Successful</h1>
                    
       </div>
       <div class="mb-4 d-flex align-items-center justify-content-center">
      <Link to={{pathname:'/writehere', }}>
      <button type='button' class="btn rounded-pill px-5" >
      Click Here To Rewrite     
      </button>
      </Link>
   </div>
       </div>
       
      </div>

      
     
    </>
    
    )
}